module.exports = __webpack_public_path__ + "img/profissionais_saude.d63387d7.png";